function triggerDownload(content, filename, mimeType) {
    const blob = new Blob([content], { type: mimeType });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = objectUrl;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(objectUrl);
}

function formatPrice(n) {
    return new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false,
    }).format(n);
}

function buildCsvRow(fields) {
    return fields.map(f => `"${String(f ?? "").replace(/"/g, '""')}"`).join(";");
}

export function exportTopProductsCsv(lineItems, startDate, endDate, entityName = "", organizationName = "", type = "top") {
    const names = [organizationName, entityName]
        .filter(Boolean)
        .filter((name, index, names) => names.indexOf(name) === index)
        .map(name => name.replace(/\s+/g, "_"));
    const slug = names.length ? `_${names.join("_")}` : "";
    const filename = `${type}_products${slug}_${startDate}_${endDate}.csv`;

    const headers = buildCsvRow(["SKU", "Product", "Brand", "Retailer", "Sales", "Stock", "Status"]);
    const rows = lineItems.map(item => buildCsvRow([
        item.sku,
        item.name,
        item.brand,
        item.retailer,
        item.sales,
        item.stock,
        item.status ? "Active" : "Inactive",
    ]));

    triggerDownload([headers, ...rows].join("\n"), filename, "text/csv; charset=utf-8");
}

export function exportRetailerRankingCsv(retailers, startDate, endDate, organizationName = "") {
    const slug = organizationName ? `_${organizationName.replace(/\s+/g, "_")}` : "";
    const filename = `retailers_ranking${slug}_${startDate}_${endDate}.csv`;

    const headers = buildCsvRow([
        "Rank",
        "Retailer",
        "Sales",
        "Product 1 SKU",
        "Product 1 sales",
        "Product 2 SKU",
        "Product 2 sales",
        "Product 3 SKU",
        "Product 3 sales",
        "Potential revenue",
        "Actual revenue",
        "Return revenue",
        "Return rate %",
        "Store cancellation",
        "Store cancellation rate %",
        "Client cancellation",
        "Client cancellation rate %",
    ]);

    const rows = retailers.map((item, index) => {
        const p = [0, 1, 2].flatMap(i => [
            item.topProducts?.[i]?.sku ?? "",
            item.topProducts?.[i]?.sales ?? "",
        ]);

        return buildCsvRow([
            index + 1,
            item.name,
            item.sales,
            ...p,
            formatPrice(item.potentialRevenue),
            formatPrice(item.actualRevenue),
            formatPrice(item.returnRevenue),
            formatPrice(item.returnRate),
            formatPrice(item.storeCancellation),
            formatPrice(item.storeCancellationRate),
            formatPrice(item.clientCancellation),
            formatPrice(item.clientCancellationRate),
        ]);
    });

    triggerDownload([headers, ...rows].join("\n"), filename, "text/csv; charset=utf-8");
}

export function exportStockAlertsCsv(exportRows, startDate, endDate, entityName = "") {
    const slug = entityName ? `_${entityName.replace(/\s+/g, "_")}` : "";
    const filename = `stock_alerts${slug}_${startDate}_${endDate}.csv`;

    const headers = buildCsvRow([
        "#",
        "SKU",
        "Sku product",
        "Product",
        "Brand",
        "Size",
        "Color",
        "Retail price",
        "Outlet price",
        "Discounted price",
        "Alerts",
        "Lost revenue"
    ]);

    const rows = exportRows.map(row => buildCsvRow([
        row.rank,
        row.sku,
        row.skuProduct,
        row.name,
        row.brand,
        row.size,
        row.color,
        formatPrice(row.retailPrice),
        row.outletPrice != null ? formatPrice(row.outletPrice) : "",
        row.discountedPrice != null ? formatPrice(row.discountedPrice) : "",
        row.alerts,
        formatPrice(row.lostRevenue),
    ]));

    triggerDownload([headers, ...rows].join("\n"), filename, "text/csv; charset=utf-8");
}
